import type { DeliveryChoice } from '../types'

export interface DeliverySlotTemplate {
  readonly id: 'thursday-pm' | 'friday-pm' | 'saturday-midday'
  readonly weekday: 4 | 5 | 6
  readonly startHour: number
  readonly startMinute: number
  readonly label: string
  readonly timezone: 'Australia/Brisbane'
  readonly status: 'proposed_pilot'
}

export const PROPOSED_DELIVERY_SLOTS = [
  {
    id: 'thursday-pm',
    weekday: 4,
    startHour: 16,
    startMinute: 0,
    label: 'Thursday, 4–7 pm',
    timezone: 'Australia/Brisbane',
    status: 'proposed_pilot',
  },
  {
    id: 'friday-pm',
    weekday: 5,
    startHour: 16,
    startMinute: 0,
    label: 'Friday, 4–7 pm',
    timezone: 'Australia/Brisbane',
    status: 'proposed_pilot',
  },
  {
    id: 'saturday-midday',
    weekday: 6,
    startHour: 11,
    startMinute: 0,
    label: 'Saturday, 11 am–3 pm',
    timezone: 'Australia/Brisbane',
    status: 'proposed_pilot',
  },
] as const satisfies readonly DeliverySlotTemplate[]

const BRISBANE_OFFSET_HOURS = 10
const BRISBANE_OFFSET_MS = BRISBANE_OFFSET_HOURS * 60 * 60 * 1000

export function nextEligibleOccurrence(
  slot: DeliverySlotTemplate,
  from: Date,
): Date {
  const brisbaneNow = new Date(from.getTime() + BRISBANE_OFFSET_MS)
  let daysAhead = (slot.weekday - brisbaneNow.getUTCDay() + 7) % 7
  const candidateUtcMs = () =>
    Date.UTC(
      brisbaneNow.getUTCFullYear(),
      brisbaneNow.getUTCMonth(),
      brisbaneNow.getUTCDate() + daysAhead,
      slot.startHour - BRISBANE_OFFSET_HOURS,
      slot.startMinute,
    )

  const candidate = new Date(candidateUtcMs())
  if (from.getTime() >= cutoffForOccurrence(slot, candidate).getTime()) {
    daysAhead += 7
  }

  return new Date(candidateUtcMs())
}

export function cutoffForOccurrence(
  slot: DeliverySlotTemplate,
  occurrence: Date,
): Date {
  const brisbaneOccurrence = new Date(
    occurrence.getTime() + BRISBANE_OFFSET_MS,
  )
  const daysBackToWednesday = slot.weekday - 3

  return new Date(
    Date.UTC(
      brisbaneOccurrence.getUTCFullYear(),
      brisbaneOccurrence.getUTCMonth(),
      brisbaneOccurrence.getUTCDate() - daysBackToWednesday,
      12 - BRISBANE_OFFSET_HOURS,
      0,
    ),
  )
}

export function createDeliveryChoice(
  slot: DeliverySlotTemplate,
  from: Date,
): DeliveryChoice {
  const nextDrop = nextEligibleOccurrence(slot, from)
  const [day, window = slot.label] = slot.label.split(', ')

  return {
    id: slot.id,
    day,
    date: new Intl.DateTimeFormat('en-AU', {
      day: 'numeric',
      month: 'short',
      timeZone: slot.timezone,
    }).format(nextDrop),
    window,
  }
}
